// extracted by mini-css-extract-plugin
module.exports = {"requiredText":"FormRequiredNote_requiredText__HVqmU","required":"FormRequiredNote_required__ozXcj"};